import axios from './index'

export default {
  fetchPaginate(params) {
    return axios.get('/api/v1/report/service/order/paginate', { params })
  },
  fetch(params) {
    return axios.get('/api/v1/report/service/order', { params })
  },
}